<template>
  <b-field :label="label"
           :label-position="labelPosition"
          :type="error ? 'is-danger' : ''"
          :message="error">
    <template v-if="searchable">
      <b-autocomplete :placeholder="placeholder"
                      :readonly="readonly"
                      open-on-focus
                      field="name"
                      expanded
                      class="select-branch-office"
                      :loading="loading"
                      :disabled="disabled"
                      :data="filteredDataArray"
                      clearable
                      :autofocus="autofocus"
                      @select="option => $emit('input', option[optionValue])"
                      ref="selectBranchOffice"
                      v-model="name">
      </b-autocomplete>
    </template>
    <b-select v-else :value="value"
              @input="val => $emit('input', val)"
              :placeholder="placeholder"
              :readonly="readonly"
              :disabled="disabled"
              :autofocus="autofocus"
              ref="selectBranchOffice"
              expanded
    >
      <option v-for="item in data"
              :value="item[optionValue]">
        {{ item[optionText] }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: "SelectBranchOffice",
  props: {
    placeholder: String,
    label: String,
    labelPosition: String,
    readonly: Boolean,
    disabled: Boolean,
    value: {},
    searchable: Boolean,
    autofocus: Boolean,
    optionText: {
      type: String,
      default: 'name'
    },
    optionValue: {
      type: String,
      default: 'id'
    },
    loading: Boolean,
    error: String|Array,
    data: {
      type: Array,
      default() {
        return this.$store.state.main.accountBranchOffices
      }
    },
  },
  data() {
    return {
      name: ''
    }
  },
  watch: {
    value(val) {
      if(val) {
        if (this.data.length > 0) {
          const found = this.data.find(el => el.id === val);
          if(found)
            this.name = found.name;
          else
            this.name = '';
        }
      } else {
        this.name = '';
      }
    }
  },
  computed: {
    filteredDataArray() {
      return this.data.filter((option) => {
        return option.name
            .toString()
            .toLowerCase()
            .indexOf(this.name.toLowerCase()) >= 0
      })
    }
  }
}
</script>

<style lang="scss">
.select-branch-office {
  .dropdown-menu {
    //position:relative;
  }
}

</style>
